export default {
  form: {
    agreement: {
      label:
        'Recunosc că acordarea aprobării mele electronice este echivalentă cu semnarea acestui document și înțeleg că semnătura mea electronică este obligatorie.',
    },
    signed_by: {
      label: 'Nume',
      placeholder: 'Nume',
    },
    signer_first_name: {
      label: 'Prenume',
      placeholder: 'Prenume',
    },
    signer_last_name: {
      label: 'Nume de familie',
      placeholder: 'Nume de familie',
    },
    recipient_email: {
      label: 'Adresa de e-mail a destinatarului',
      placeholder: 'Introduceți adresa de e-mail',
    },
    send_to_email: {
      label: 'Trimiteți contractul proprietarului prin e-mail ({{email}})',
    },
    additional_locations: {
      label: 'Locații suplimentare',
      placeholder: 'Căutați o locație de adăugat',
    },
    special_agreements: {
      label: 'Acorduri speciale',
      placeholder: 'Introduceți acordurile speciale',
    },
  },
  labels: {
    name: 'Nume',
    date: 'Data',
  },
  buttons: {
    sign_in_person: 'Semnează aici împreună cu proprietarul',
    back: 'Înapoi',
    edit_contract: 'Editați contractul',
    skip: 'Omiteți',
    sign: 'Semnați',
    init_sign: 'Creați contractul și trimiteți',
    redo: 'Refaceți',
    continue: 'Continuați',
    preview: 'Previzualizare',
    submit: 'Trimiteți',
  },
  toasts: {
    failed_to_preview_contract: 'Eroare la previzualizarea contractului',
    contract_signing_pending: 'Așteptați, inițiem contractul...',
    failed_to_sign_contract: 'Eroare la inițierea contractului ⁉️',
    contract_got_signed: 'Contractul a fost inițiat 👌',
  },
  in_person_signing: {
    description:
      'Proprietarul a primit acest link prin e-mail și poate semna de la distanță. Dacă proprietarul este lângă dumneavoastră acum, deschideți aici pagina de semnare.',
  },
  signature_link: {
    label: 'Link semnătură (același link trimis destinatarului prin e-mail)',
    copy: 'Copiați',
    copied: 'Linkul semnăturii a fost copiat în clipboard',
  },
  header: 'Creați contractul',
  description: 'Revizuiți detaliile contractului și introduceți adresa de e-mail la care trebuie trimis contractul.',
};
